/**
 * Same summary pattern for CSV import completed / bulk delete completed modals.
 */

export function formatBatchSummaryMessage(operationHeading, successCount, errorCount, errors, maxDetail = 10) {
  const errorList = Array.isArray(errors) ? errors : [];
  let message = `${operationHeading}\nSuccess: ${successCount}\nErrors: ${errorCount}`;
  if (errorList.length > 0 && errorList.length <= maxDetail) {
    message += "\n\nErrors:\n" + errorList.join("\n");
  } else if (errorList.length > maxDetail) {
    message += `\n\nFirst ${maxDetail} errors:\n` + errorList.slice(0, maxDetail).join("\n");
  }
  return message;
}
